<template>
  <div>
    <div v-if="loader.getSystemInformationData || loader.selectCRMAgentFromCRMAgentView" style="width: 100%; height: 100vh; display: flex; justify-content: center; align-items: center;">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </div>
    <div v-else-if="display.CRMAgent" style="height: 100vh; overflow-y: hidden; display: flex; flex-direction: column;">
      <v-card color="primary" elevation="0" rounded="0" style="padding: 15px; height: 100%;">
        <div style="display: flex; flex-direction: row; height: 100%; gap: 15px;">
          <v-card color="borderInner" elevation="0" rounded="0" style="width: 15%; height: 100%; display: flex; flex-direction: column;">
            <div style="padding: 15px; text-align: center; cursor: default; user-select: none;">
              <img 
                :src="display.CRMAgent.CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" 
                draggable="false"
                style="width: 100%; aspect-ratio: 1 / 1; object-fit: cover; border-radius: 50%; display: block;"
              >
              <v-chip :color="display.CRMAgent.CRMAgentColor" variant="flat" style="margin-top: 10px;">
                <h2 style="margin: 0;">{{ display.CRMAgent.CRMAgentName }}</h2>
              </v-chip>
            </div>
            <div style="margin-top: auto;">
              <v-divider></v-divider>
              <v-card-actions style="display: flex; flex-direction: column;">
                <v-btn @click="navigation.CRMAgentTab = 'CRMAgentGeneralSettings'; $generalFunctions.default.navigateTo(`/CRMAgent/${navigation.CRMAgentID}/CRMAgentGeneralSettings`)" :color="navigation.CRMAgentTab == 'CRMAgentGeneralSettings' ? 'primary' : 'grey'" block variant="text" class="hoverableText" style="text-transform: none !important; font-weight: 500; height: 40px !important; justify-content: flex-start !important;">
                  <v-icon>mdi-account-cog</v-icon>
                  <span class="ml-2">Configuración general</span>
                </v-btn>
                <v-btn v-if="systemInformationData.CRMAgent?.CRMAgentPermissions.find((CRMAgentPermission) => CRMAgentPermission.CRMAgentPermissionName == '/CRMAgent/CRMAgentAccessPermissions')?.CRMAgentPermissionValue == '1'" @click="navigation.CRMAgentTab = 'CRMAgentPermissions'; $generalFunctions.default.navigateTo(`/CRMAgent/${navigation.CRMAgentID}/CRMAgentPermissions`)" :color="navigation.CRMAgentTab == 'CRMAgentPermissions' ? 'primary' : 'grey'" block variant="text" class="hoverableText" style="text-transform: none !important; font-weight: 500; height: 40px !important; justify-content: flex-start !important;">
                  <v-icon>mdi-account-lock</v-icon>
                  <span class="ml-2">Permisos</span>
                </v-btn>
                <v-btn @click="navigation.CRMAgentTab = 'CRMAgentQuickMessages'; $generalFunctions.default.navigateTo(`/CRMAgent/${navigation.CRMAgentID}/CRMAgentQuickMessages`)" :color="navigation.CRMAgentTab == 'CRMAgentQuickMessages' ? 'primary' : 'grey'" block variant="text" class="hoverableText" style="text-transform: none !important; font-weight: 500; height: 40px !important; justify-content: flex-start !important;">
                  <v-icon>mdi-message-flash</v-icon>
                  <span class="ml-2">Mensajes rápidos</span>
                </v-btn>
                <!--
                <v-btn @click="navigation.CRMAgentTab = 'CRMAgentTemplateMessages'; $generalFunctions.default.navigateTo(`/CRMAgent/${navigation.CRMAgentID}/CRMAgentTemplateMessages`)" :color="navigation.CRMAgentTab == 'CRMAgentTemplateMessages' ? 'primary' : 'grey'" block variant="text" class="hoverableText" style="text-transform: none !important; font-weight: 500; height: 40px !important; justify-content: flex-start !important;">
                  <v-icon>mdi-message-bookmark</v-icon>
                  <span class="ml-2">Mensajes de plantilla</span>
                </v-btn>
                -->
                <v-btn @click="navigation.CRMAgentTab = 'CRMAgentStickers'; $generalFunctions.default.navigateTo(`/CRMAgent/${navigation.CRMAgentID}/CRMAgentStickers`)" :color="navigation.CRMAgentTab == 'CRMAgentStickers' ? 'primary' : 'grey'" block variant="text" class="hoverableText" style="text-transform: none !important; font-weight: 500; height: 40px !important; justify-content: flex-start !important;">
                  <v-icon>mdi-emoticon-wink</v-icon>
                  <span class="ml-2">Stickers</span>
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>
          <v-card elevation="0" rounded="0" color="borderInner" style="width: 85%; height: 100%;">
            <CRMAgentGeneralSettingsComponent v-if="navigation.CRMAgentTab == 'CRMAgentGeneralSettings'"/>
            <CRMAgentPermissionsComponent v-if="navigation.CRMAgentTab == 'CRMAgentPermissions'"/>
            <CRMAgentQuickMessagesComponent v-if="navigation.CRMAgentTab == 'CRMAgentQuickMessages'"/>
            <CRMAgentTemplateMessagesComponent v-if="navigation.CRMAgentTab == 'CRMAgentTemplateMessages'"/>
            <CRMAgentStickersComponent v-if="navigation.CRMAgentTab == 'CRMAgentStickers'"/>
          </v-card>
        </div>
      </v-card>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import CRMAgentGeneralSettingsComponent from './CRMAgentGeneralSettingsComponent.vue';
  import CRMAgentPermissionsComponent from './CRMAgentPermissionsComponent.vue';
  import CRMAgentQuickMessagesComponent from './CRMAgentQuickMessagesComponent.vue';
  import CRMAgentTemplateMessagesComponent from './CRMAgentTemplateMessagesComponent.vue';
  import CRMAgentStickersComponent from './CRMAgentStickersComponent.vue';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components: 
    {
      CRMAgentGeneralSettingsComponent,
      CRMAgentPermissionsComponent,
      CRMAgentQuickMessagesComponent,
      CRMAgentTemplateMessagesComponent,
      CRMAgentStickersComponent
    },
    data: () => ({
      display:
      {
        CRMAgent: null
      },
      navigation: 
      {
        CRMAgentID: null,
        CRMAgentTab: null
      },
      loader:
      {
        getSystemInformationData: false,
        selectCRMAgentFromCRMAgentView: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    methods: {
      async selectCRMAgentFromCRMAgentView() {
        this.loader.selectCRMAgentFromCRMAgentView = true;
        const selectCRMAgentFromCRMAgentViewRequestQuery = 
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.navigation.CRMAgentID
          }
        };
        const selectCRMAgentFromCRMAgentViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/functions/selectCRMAgentFromCRMAgentView', selectCRMAgentFromCRMAgentViewRequestQuery);
        if (selectCRMAgentFromCRMAgentViewResult.success){
          this.display.CRMAgent = selectCRMAgentFromCRMAgentViewResult.result;
          this.loader.selectCRMAgentFromCRMAgentView = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMAgentFromCRMAgentView_error', 'error', 'Ha ocurrido un error inesperado al abrir el perfil del agente, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      },
      
      async getSystemInformationData() {
        try {
          this.loader.getSystemInformationData = true;
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
            this.loader.getSystemInformationData = false;
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      }
    },

    async mounted() {
      if (this.$route.params.CRMAgentID) this.navigation.CRMAgentID = this.$route.params.CRMAgentID;
      if (this.$route.params.CRMAgentTab) this.navigation.CRMAgentTab = this.$route.params.CRMAgentTab;
      await this.getSystemInformationData();
      await this.selectCRMAgentFromCRMAgentView();
    },

    beforeUnmount(){
      if (this.systemInformationData.updateSubscription) {
        systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
        this.systemInformationData.updateSubscription = null;
      }
    }
  }
</script>
